import { clone } from 'ramda';

import { resetTerms, setTerm } from './helpers';
import { EFacilityType, type NonEmptyArray, type TJsonQuery } from './types';

export function setSuburbanFacilityTypes(jsonQuery: TJsonQuery) {
  return (facilityTypes: NonEmptyArray<EFacilityType> | null): TJsonQuery => {
    let nextJsonQuery = clone(jsonQuery);

    nextJsonQuery = resetTerms([
      'bathhouse',
      'garage',
      'security',
      'pool',
      'conditioner',
      'has_furniture',
      'has_kitchen_furniture',
      'internet',
      'has_fridge',
      'dish_washer',
      'tv',
      'has_washer',
    ])(nextJsonQuery);

    if (facilityTypes) {
      if (facilityTypes.includes(EFacilityType.Sauna)) {
        nextJsonQuery = setTerm('bathhouse')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.Garage)) {
        nextJsonQuery = setTerm('garage')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.Security)) {
        nextJsonQuery = setTerm('security')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.Pool)) {
        nextJsonQuery = setTerm('pool')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.Conditioner)) {
        nextJsonQuery = setTerm('conditioner')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.RoomFurniture)) {
        nextJsonQuery = setTerm('has_furniture')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.KitchenFurniture)) {
        nextJsonQuery = setTerm('has_kitchen_furniture')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.Internet)) {
        nextJsonQuery = setTerm('internet')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.Fridge)) {
        nextJsonQuery = setTerm('has_fridge')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.Dishwasher)) {
        nextJsonQuery = setTerm('dish_washer')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.TV)) {
        nextJsonQuery = setTerm('tv')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.Washer)) {
        nextJsonQuery = setTerm('has_washer')(nextJsonQuery)(true);
      }
    }

    return nextJsonQuery;
  };
}
